angular.module('purchase-frequency')
    .directive('purchaseFrequencyPicker', function (PurchaseFrequency, PurchaseFrequencyService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: false,
            scope: {
                required: "=",
                onChange: "&",
                filterField: "=?",
                modelType: "=?",
                disableList: "=?",
                disableAdd: "=?"
            },
            templateUrl: "app/purchase-frequency/picker/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.filterStyle = scope.filterField || false
                scope.modelType = scope.modelType || "object"
                scope.disableList = scope.disableList || false
                scope.disableAdd = scope.disableAdd || false

                scope.executeOnChange = scope.onChange || angular.noop
                loadItems()

                function loadItems(){
                    PurchaseFrequency.autocomplete().$promise.then(items => scope.items = items)
                }

                scope.add = () => PurchaseFrequencyService.add().then(() => loadItems())
                scope.list = () => PurchaseFrequency.autocomplete().then(() => loadItems())

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelType === "id" ? viewValue.id : viewValue)

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
